import axios from "axios";

var emailMeetingMinutes = function emailMeetingMinutes(groupId, meetingId, request) {
  return axios.post("/groups/" + groupId + "/meetings/" + meetingId + "/email-meeting-minutes", request);
};

var getEmailTemplatePreview = function getEmailTemplatePreview(groupId, meetingId, emailType) {
  return axios.get("/groups/" + groupId + "/meetings/" + meetingId + "/email-preview", {
    params: {
      email_type: emailType
    }
  });
};

export { emailMeetingMinutes, getEmailTemplatePreview };